import React from "react";

import { isString } from "lodash-es";
import {
  FieldError,
  FieldErrorsImpl,
  Merge,
  UseFormRegisterReturn,
} from "react-hook-form";

import { MonospacedInput } from "src/base-components/MonospacedInput";
import { Tooltip } from "src/design-system/Tooltip";
import { getEnumError } from "src/schema/enumUtils";
import { PropertyUI } from "src/schema/schemaMappingUtils";

export const SchemaEnumInput: React.FC<{
  disabled: boolean;
  errorStatus?: Merge<FieldError, FieldErrorsImpl<PropertyUI>>;
  formProps: UseFormRegisterReturn;
  searchHighlightKey?: string;
}> = ({ errorStatus, disabled, formProps, searchHighlightKey }) => {
  const hasError = errorStatus !== undefined;
  const enumError = isString(errorStatus?.type)
    ? getEnumError(errorStatus.type)
    : null;

  return (
    <Tooltip
      body={enumError?.description ?? ""}
      disabled={!hasError}
      placement="top"
      title={enumError?.title}
      asChild
    >
      <div className="grow">
        <MonospacedInput
          containerClassName="w-full"
          disabled={disabled}
          errored={hasError}
          formProps={formProps}
          inputDataLoc="schema-enum-value"
          searchHighlightKey={searchHighlightKey}
          codeColors
          errorIconOnError
        />
      </div>
    </Tooltip>
  );
};
